import React from "react";
import { Link, Outlet, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { Navigate } from "react-router-dom";
import i18n from "i18next";

const ProtectedLayout = () => {
  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);
  // const driverInfo = useAppSelector((state) => state.auth.driverInfo);
  // 从wordpress跳转
  const [searchParams] = useSearchParams();
  // console.log("searchParams", searchParams);
  const isFromWordPress = searchParams.get('source') === 'wordpress';
  const lang = isFromWordPress ? searchParams.get('lang') || 'en' : localStorage.getItem('userLanguage') || 'en';

  if (!basicUserInfo) {
    //console.log("lang2", lang, isFromWordPress);
    if (isFromWordPress) {
      localStorage.setItem('userLanguage', lang);
      i18n.changeLanguage(lang);
    }
    return <Navigate replace to={"/login"} />;
  }
  // if (!basicUserInfo && !driverInfo) {
  //   return <Navigate replace to={"/login"} />;
  // }

  return (
    <>
      <Outlet />
    </>
  );
};

export default ProtectedLayout;
